import store from './store';

// Valida se o código de barras é vaĺido com o id_produto
// os primeiros 6 digitos do código de barras é o id_produto
export function barcodeIsValidWithProductId(barcode, idProduto) {
  const formattedBarcode = barcode ? barcode.substr(0, 6) : null;
  return idProduto == formattedBarcode;
}

// Valida se o lote padrão é o mesmo sendo pistolado
// os primeiros 12 digitos do código de barras é o id_produto + lote_padrao
export function barcodeLoteIsValidWithLotePadrao(barcode, lote_padrao) {
  const formattedBarcode = barcode ? barcode.substr(0, 12) : null;
  return lote_padrao == formattedBarcode;
}

export function blinkBackground(idElement, status, timeout = 500) {
  const cssClass = status === 'success' ? 'bgBlinkSuccess' : 'bgBlinkError';
  document.getElementById(idElement).classList.add(cssClass);
  setTimeout(() => document.getElementById(idElement).classList.remove(cssClass), timeout);
}

export function toggleLight(on) {
  //Test browser support
  const SUPPORTS_MEDIA_DEVICES = 'mediaDevices' in navigator;

  if (SUPPORTS_MEDIA_DEVICES) {
    //Get the environment camera (usually the second one)
    navigator.mediaDevices.enumerateDevices().then(devices => {
    
      const cameras = devices.filter((device) => device.kind === 'videoinput');

      if (cameras.length === 0) {
        throw 'No camera found on this device.';
      }
      const camera = cameras[cameras.length - 1];

      // Create stream and get video track
      navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: camera.deviceId,
          facingMode: ['environment'],
          height: {ideal: 1080},
          width: {ideal: 1920}
        }
      }).then(stream => {
        const track = stream.getVideoTracks()[0];

        //Create image capture object and get camera capabilities
        const imageCapture = new ImageCapture(track)
        return imageCapture.getPhotoCapabilities().then(() => {
          if (!on) {
            return track.applyConstraints({
              advanced: [{ torch: false }]
            }).catch(() => store.commit('SHOW_SNACKBAR', { text: 'Flash não disponível', status: 'error' }));
          } else {
            return track.applyConstraints({
              advanced: [{ torch: true }]
            }).catch(() => store.commit('SHOW_SNACKBAR', { text: 'Flash não disponível', status: 'error' }));
          }
        });
      });
    });
  }
}

export function convertStartEndPerformanceMstoSeconds(start = 0, end = 0) {
  return ((end - start) / 1000).toFixed(4);
}